
import { defineComponent } from "vue";

export default defineComponent({
  name: "FinalBlock",

  props: {
    text: String,
  },
});
